import {
  useIntersectionObserver
} from "./chunk-PGPGX7B5.mjs";

// src/components/InView.tsx
import { Children, cloneElement } from "react";
import { jsx } from "react/jsx-runtime";
var EMPTY_CHILDREN_WARNING = "InView\uC5D0\uB294 \uCD5C\uC18C \uD558\uB098 \uC774\uC0C1\uC758 \uC790\uC2DD \uC694\uC18C\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4.";
function InView({ children, ...options }) {
  const { ref: observeRef } = useIntersectionObserver(options);
  const count = Children.count(children);
  if (count < 1 || !children) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(EMPTY_CHILDREN_WARNING);
    }
    return null;
  }
  return count > 1 ? /* @__PURE__ */ jsx("div", { ref: observeRef, children }) : cloneElement(children, { ref: observeRef });
}

export {
  InView
};
